export default "__VITE_ASSET__CNaR3w0P__"